export default __webpack_public_path__ + "static/media/eurostile_extended_black.2e7d046f.ttf";